const MEETINGS = {
    BUTTONS: {
        CREATE: 'Create Case',
        JOIN: 'Join',
        JOIN_MEETING: 'Join Meeting',
        RESCHEDULE: 'Reschedule',
        CANCEL: 'Cancel',
    },
    CASE_MEETINGS: 'Case Meetings',
    CELL_TYPE_HOST: 'HOST',
    CELL_TYPE_INVITEE: 'INVITEE',
    CELL_TYPE_RECAP: 'RECAP',
    DEFAULT_QUESTION_RECAP: 'Here is a recap of our meeting.',
    EDIT_INVITEE: {
        TITLE: 'Edit Invitee',
        LABEL: 'Select A User',
        PLACEHOLDER: 'Search by Name, Email, Username, Job Title, Phone',
        CONFIRM: 'Confirm Invitee',
    },
    EDIT_HOST: {
        TITLE: 'Edit Host',
        LABEL: 'Select A User',
        PLACEHOLDER: 'Search by Name, Email, Username, Job Title, Phone',
        CONFIRM: 'Confirm Host',
    },
    HOVER_TEXT_HOST: 'Mineral User #${hostId}',
    HOVER_TEXT_INVITEE: 'Mineral User #${inviteeId}',
    HOVER_TEXT_RECAP: 'Case #${recapId}',
    HOVER_TEXT_RECAP_CREATE: 'Create Recap Case...',
    HOVER_TEXT_RECAP_EDIT_HOST: 'Edit Host (required before Recap Case can be created)',
    HOVER_TEXT_RECAP_EDIT_INVITEE: 'Edit Invitee (required before Recap Case can be created)',
    NO_DATA: 'No meetings found.',
    PAGE_LABEL: 'Meetings',
    PAST_MEETINGS: 'PAST MEETINGS',
    STATUS_CANCELLED: 'Cancelled',
    STATUS_COMPLETE: 'Complete',
    STATUS_UPCOMING: 'Upcoming',
    VIEW_MY_EVENTS: 'View My Scheduled Events',
    VIEW_MY_EVENTS_URL: 'https://calendly.com/app/scheduled_events/user/me',
};

export const MY_MEETINGS = {
    label: 'My Meetings',
    noData: 'You do not have any past or upcoming meetings with your Dedicated HR Expert.',
    path: '/my-cases/my-meetings',
    value: 'myMeetings',
};

export default MEETINGS;
